export const initialState = {
    wins: [],
};